<template>

  <modalo
    :title="videoform.name"
    type="medium"
    @hideModal="hideModal()"
    :modaloWatch="() => videoform">

      <form
        id="videoform-form"
        v-on:submit.prevent="saveVideoform(videoform)">
        <div class="form-group">
          <label>{{ $t('Name') }}</label>
          <input
            v-autofocus
            type="text"
            class="form-control"
            v-model="videoform.name">
          <ValidateMessage :error="validateErrors.name" />
        </div>

        <div class="form-group mb-3">
          <label>{{ $t('Message') }}</label>
          <input 
            type="text" 
            class="form-control mb-1" 
            v-model="videoform.subject" 
            :placeholder="$t('Subject')">
          <ValidateMessage :error="validateErrors['subject']" />
          <textarea-editable
            v-model="videoform.body"
            :variables="['[candidate_full_name]', '[candidate_first_name]', '[job_title]', '[company_name]', '[member_full_name]', '[member_first_name]']"
            editor-model="html"
            :enable-link="true"
            :enable-img="true">
            </textarea-editable>
          <ValidateMessage :error="validateErrors['body']" />
        </div>

        <label>{{ $t('Questions') }}</label>

        <div 
          class="list-form" 
          v-sortable="{ handle: '.sortable-move', items: videoform.questions}">
          <div
            class="card"
            v-for="(item, index) in videoform.questions"
            :key="index">
            
            <div class="card-header">
              <div class="d-flex justify-content-between">
                <div class="mr-auto">
                  <a
                    href="javascript:void(0)"
                    class="sortable-move text-secondary">
                    <i class="fas fa-arrows-alt" />
                    </a>
                </div>
                <div>
                  <a
                    href="javascript:void(0)"
                    class="text-secondary"
                    @click="removeQuestion(index)">
                    <i class="far fa-trash-alt" />
                    </a>
                </div>
              </div>
            </div>
          
            <div class="card-body">
              <div class="form-group">
                <input 
                  type="text" 
                  :placeholder="$t('Question')" 
                  class="form-control" 
                  v-model="item.label">
                <ValidateMessage :error="validateErrors['questions.' +index+ '.label']" />
              </div>

              <div class="form-group">
                <select
                  type="text"
                  class="form-control"
                  v-model="item.time_limit">
                  <option :value="30">{{  $tc('n_seconds', 30)  }}</option>
                  <option :value="60">{{  $tc('n_seconds', 60)  }}</option>
                </select>
                <ValidateMessage :error="validateErrors['questions.' +index+ '.time_limit']" />
              </div>
            </div>

          </div>
        </div>
        
        <div>
          <a
            href="javascript:void(0)"
            @click="addQuestion()">{{ $t('Add question') }}</a>
        </div>

      </form>

      <template slot="footer">
        <div :class="{'box-loading': loading}">
          <button
            type="submit"
            form="videoform-form"
            class="btn btn-primary">{{ $t('Save') }}</button>
          <button
            type="button"
            class="btn btn-light"
            @click="hideModal()">{{ $t('Cancel') }}</button>
          <!--<button
              type="button"
              class="btn btn-danger"
              @click="deleteVideoform(videoform._id)">{{ $t('Delete') }}</button>-->
        </div>
      </template>

  </modalo>

</template>

<script>
import Modalo from '@/components/Modalo/Modalo'

export default {
  name: 'VideoformForm',
  components: {
    Modalo
  },
  props: [
    'initVideoform'
  ],
  data () {
    return {
      loading: false,
      videoform: this.defaultValues(this.initVideoform),
      validateErrors: false
    }
  },
  created () {
  },
  methods: {
    /*
    defaultValues
    */
    defaultValues (values) {
      return values._id
      ? this.$clone(values)
      : Object.assign({
        'questions': [{
          'label': '',
          'time_limit': 30
        }]
      }, values)
    },
    addQuestion () {
      var newItem = {
        'label': '',
        'time_limit': 30
      }

      this.videoform.questions.push(newItem)
    },
    removeQuestion (index) {
      this.videoform.questions.splice(index, 1)
    },
    /*
    hideModal
    */
    hideModal () {
      this.$emit('hideModal')
    },
    /*
    saveVideoform
    */
    saveVideoform (data) {
      if (data._id) this.updateVideoform(data)
      else this.createVideoform(data)
    },
    /*
    createVideoform
    */
    createVideoform (data) {
      this.loading = true

      this.$store
      .dispatch('createVideoform', data)
      .then((result) => {
        this.loading = false
        this.$emit('saved')
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    updateVideoform
    */
    updateVideoform (data) {
      this.loading = true

      this.$store
      .dispatch('updateVideoform', data)
      .then((result) => {
        this.loading = false
        this.$emit('saved')
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    delete
    */
    deleteVideoform (id) {
      const deleteAction = () => {
        this.loading = true

        this.$store
        .dispatch('deleteVideoform', id)
        .then((result) => {
          this.loading = false
          this.$emit('saved')
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Videoform/VideoformForm.vue